import axiosInstance from '../lib/axios'
import { API_ENDPOINTS } from '../constants/api'
import type { OTARelease, ReleaseType } from '../types/api.types'

export interface OTAReleaseCreate {
  version: string
  release_type: ReleaseType
  release_notes?: string | null
  download_url: string
  checksum_sha256: string
  min_hardware_version?: string | null
  is_active?: boolean
}

export const otaService = {
  async list(isActive?: boolean): Promise<OTARelease[]> {
    const qs = isActive !== undefined ? `?is_active=${isActive}` : ''
    const { data } = await axiosInstance.get<OTARelease[]>(`${API_ENDPOINTS.PLATFORM_OTA_RELEASES}${qs}`)
    return data
  },

  async create(payload: OTAReleaseCreate): Promise<OTARelease> {
    const { data } = await axiosInstance.post<OTARelease>(API_ENDPOINTS.PLATFORM_OTA_RELEASES, payload)
    return data
  },

  async update(id: number, payload: Partial<OTAReleaseCreate>): Promise<OTARelease> {
    const { data } = await axiosInstance.put<OTARelease>(API_ENDPOINTS.PLATFORM_OTA_RELEASE_BY_ID(id), payload)
    return data
  },
}
